module.exports = __webpack_public_path__ + "static/img/solution-quietram.f2df0ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solutions/solution-quietram.png
// module id = U62T
// module chunks = 0